// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Redux:
import { setHasSeenVotdIntro } from 'actions/site'

class VersesIntro extends React.Component {
	handleClick = () => {
		this.props.dispatch( setHasSeenVotdIntro() )
	}

	render() {
		const { page } = this.props

		return (
			<div className="votd-page-intro">
				{ page && page.votd_page_intro.rendered &&
					<div dangerouslySetInnerHTML={ { __html: page.votd_page_intro.rendered } } />
				}

				<p>
					<div className="button" onClick={ this.handleClick }>Show verses</div>
				</p>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( VersesIntro )
